/**
 * 统一的Toast API，根据当前平台自动选择实现
 */

import { currentPlatform, PlatformType } from '../platform';
import { Toast as WebToast } from '../../UI/Toast';
import { nativeBridge } from '@whelk/utils/src/bridge/callNativeBridge';

const NativeToast = () => {
  const showToast = (content: string) => {
    nativeBridge.callNative({
      methodName: 'toast',
      params: {
        content: content || '',
      },
    });
  };
  return {
    show: showToast,
    info: showToast,
    error: showToast,
    warning: showToast,
    success: showToast,
    clear: showToast,
  };
};

// 创建一个根据平台确定的Toast对象
const ToastImpl = (() => {
  switch (currentPlatform) {
    case PlatformType.WEB:
      return WebToast;
    case PlatformType.NATIVE:
      return NativeToast();
    default:
      // web toast 兜底
      return WebToast;
  }
})();

// 直接导出对象，而不是函数
export const Toast = ToastImpl;
